"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureFramework = void 0;
const base_1 = require("./base");
const configureFramework = (Session) => (0, base_1.configureFramework)(Session);
exports.configureFramework = configureFramework;
//# sourceMappingURL=index.js.map